import { DisplayModeEnum } from './enum';

export const MAP_RULE_DISPLAY_TIME_LABEL = {
  [DisplayModeEnum.AllTime]: 'All time',
  [DisplayModeEnum.SpecificDays]: 'Specific days and time of the week',
  [DisplayModeEnum.DateRange]: 'Specific date and time range',
};
